import { connect } from 'react-redux';

import { PagesActions } from '../../store/pages/pages.actions';
import { AppState } from '../../store/store';

import { Navbar as Presentation } from './navbar.component';

export const Navbar = connect(
  (state: AppState) => ({
    open: state.layout.navbar,
  }),
  (dispatch) => ({
    selectPage: (page: number) => { dispatch(PagesActions.selectPage(page)); },
  }),
)(Presentation);
